import Yt from "./filter-set.js";
export default class Zt {
  constructor(t, s) {
    (this.yl = t), (this.Jl = s), (this.yl = t), (this.Jl = s);
  }
  Bl(t) {
    if (null == this.yl || null == this.Jl) return !1;
    const s = t[0],
      i = t[1];
    return s === this.yl && this.Jl.Bl(i);
  }
  static fromJson(t) {
    return new Zt(
      t ? t.event_name : null,
      t ? Yt.fromJson(t.property_filters) : null,
    );
  }
  ss() {
    return { e: this.yl, pf: this.Jl ? this.Jl.ss() : null };
  }
}
